(function (Drupal, once, $, settings) {
    Drupal.behaviors.accordion = {
      attach: function attach(context) {
        const elements = once('bind-accordion-once', '.accordion-list');
        elements.forEach(function(value, index){
          $('.paragraph--type--accordion-item', $(value)).each(function(idx, val){
            $('.field-item__field-accordion-item-heading > a, .accordion-icon > button', $(val)).each(function(){
              $(this).bind('click', function(e){
                e.preventDefault();
                console.log('Trigger element clicked.');
                toggle($(this));
                return false;
              });
            });
          });
        });

        let toggle = (el) => {
          $(el).toggleClass("active");
          $(el).attr('aria-expanded', function(index, attr){
            return attr == 'true' ? 'false' : 'true';
          });
          $(el).parent().parent().find('.field-item__field-body').slideToggle({duration: 600});
        };
      }
    };
  }
)(Drupal, once, jQuery, drupalSettings);
